<template>
  <section>
    <div class="container">

      <div class="hero is-bold">
        <div class="hero-body" style="padding-left: 0px; padding-top: 0px">
          <div class="container">
            <h1 class="title" style="color:#3e8ed0">Playlists</h1>
            <h4 class="subtitle">Manage the playlists for your clusters here.</h4>
          </div>
        </div>
      </div>

      <div class="columns is-multiline is-mobile">
        <div class="column is-4 is-offset-1 box" border-width="thick" v-for="(playlist, playlistId) in playlists" :key="playlistId">
          <div class="level" >
            <div class="level-left">
              <!-- <router-link style="font-size:17.5px;color:#3e8ed0" class="level-item" :to="{ name: 'PlaylistDetails', params: { id: playlistId }}" ><b>{{playlist.name}}</b></router-link> -->
            <div style="font-size:17.5px;color:#3e8ed0;cursor:pointer" class="level-item" @click="editPlaylist(playlistId)"><b>{{showPlaylistName(playlist.name)}}</b></div>
            </div>
            <div class="level-right">
              <div class="level-item">
                <b-button icon-left="edit" class="button is-info" @click="editPlaylist(playlistId)"
                >Edit</b-button>
              </div>
              <div class="level-item">
                <b-button icon-left="trash" class="button is-danger" @click="confirmRemove(playlistId, playlist.name)"
                :disabled="role === 'viewer'"></b-button>
              </div>
            </div>
          </div>
          <p><b>Number of items:</b> {{playlist.items ? playlist.items.filter(x => x).length : 'N/A'}}</p>
        </div>
      <div></div>
      </div>
      <!--<p>{{ role }} {{ workspaceId }}</p>-->
      <vue-fab v-if="!bPlaylistAdd" title="Add Playlist" :scrollAutoHide="autoHide" mainBtnColor="#48c78e" icon="add" size="big" @clickMainBtn="addPlaylist" :hidden="role === 'viewer'"/>
    </div>
  </section>
</template>

<script>
import PlaylistAddEdit from '@/components/playlists/PlaylistAddEdit'

export default {
  name: 'Playlists',
  data: () => {
    return {
      bPlaylistAdd: false,
      loadingComponent: null,
      autoHide: false,
      archiveItems: [],
      totalStorageSize: null,
      jsonResp: null,
      campaignsAddOn: false,
      campFlag: false,
      campaignsToDelete: [],
      clusterIds: []
    }
  },
  created: function () {
    fetch('https://api.seeip.org/geoip').then(
      (response) => response.json()
    ).then(
      (jsonResponse) => {
        this.jsonResp = jsonResponse
        this.globalLogger(this.jsonResp)
      }
    )
    if (this.$store.state.addOns !== null) {
      if (this.$store.state.addOns.campaigns === true) {
        this.campaignsAddOn = true
      }
    }
  },
  mounted: function () {
    this.refreshData()
    if (!localStorage.getItem('isShown')) {
      // if (localStorage.getItem('isShown') === 'undefined' || localStorage.getItem('isShown') === null) {
      setTimeout(() => {
        var resp = this.storageAlmostFull()
        if (resp) {
          this.globalLogger('odgovor e true')
          this.$buefy.dialog.confirm({
            title: 'Storage almost full',
            message: 'You have used up 95% of your available storage.',
            hasIcon: true,
            confirmText: 'OK',
            type: 'is-danger'
          })
          localStorage.isShown = true
        }
      }, 1000)
    }
  },
  computed: {
    playlists () {
      return this.$store.state.playlists
    },
    menus () {
      return this.$store.state.menus
    },
    specialOffers () {
      return this.$store.state.specialOffers
    },
    playlistsArchive () {
      return this.$store.state.playlistsArchive
    },
    menusArchive () {
      return this.$store.state.menusArchive
    },
    specialOffersArchive () {
      return this.$store.state.specialOffersArchive
    },
    campaigns () {
      return this.$store.state.campaigns
    },
    role () {
      return this.$store.state.role
    },
    testItems () {
      return this.$store.state.items
    },
    workspaceId () {
      return this.$store.state.workspaceId
    },
    userId () {
      return this.$store.state.uid
    }
  },
  methods: {
    addPlaylist () {
      this.bPlaylistAdd = true
      this.$buefy.modal.open({
        parent: this,
        component: PlaylistAddEdit,
        props: { propParentFn: this.cancelAdd },
        hasModalCard: true,
        trapFocus: true,
        onCancel: this.cancelAdd,
        canCancel: ['x']
      })
    },
    editPlaylist (id) {
      this.bPlaylistAdd = true
      const modal = this.$buefy.modal.open({
        parent: this,
        component: PlaylistAddEdit,
        props: { editEnabled: true, propId: id, propParentFn: this.cancelAdd },
        hasModalCard: true,
        trapFocus: true,
        onCancel: this.cancelAdd,
        canCancel: ['x']
      })
      modal.$on('close', () => {
        this.refreshData()
      })
    },
    confirmRemove (id, name) {
      if (this.role !== 'viewer') {
        var flag = false
        var playlistRef = Object.assign({}, this.$store.getters.getPlaylist(id))
        if (playlistRef.items !== undefined) {
          var playlistItems = [...playlistRef.items.filter(x => x)]
          for (let i = 0; i < playlistItems.length; i++) {
            if (playlistItems[i].resourceName !== undefined && playlistItems[i].resourceName !== '') {
              flag = true
            }
          }
        }
        this.campFlag = false
        this.campaignsToDelete = []
        var message = 'Are you sure you want to <b>delete</b> playlist "' + name + '"? This action cannot be undone.'
        if (this.campaignsAddOn) {
          if (this.campaigns !== null) {
            const keys = Object.keys(this.campaigns)
            keys.forEach((key, index) => {
              let cl = this.campaigns[key] // kampanji po cluster
              const newKeys = Object.keys(this.campaigns[key])
              newKeys.forEach((newKey, newIndex) => {
                this.globalLogger('pl id', cl[newKey].playlistId) // kampanja
                if (cl[newKey].playlistId === id) {
                  this.campFlag = true
                  this.campaignsToDelete.push(newKey)
                  this.clusterIds.push(key)
                }
              })
            })
            this.globalLogger(this.campFlag, 'camp flag')
            this.globalLogger(this.campaignsToDelete, 'camps to del')
            this.globalLogger(this.clusterIds, 'cluster ids')
            if (this.campFlag) {
              if (this.campaignsToDelete.length > 1) {
                message = 'Playlist "' + name + '" is being used by ' + this.campaignsToDelete.length + ' campaigns. If you <b>delete</b> it, the campaigns will be <b>deleted</b> as well. Do you want to proceed? This action cannot be undone.'
              } else {
                message = 'Playlist "' + name + '" is being used by a campaign. If you <b>delete</b> it, the campaign will be <b>deleted</b> as well. Do you want to proceed? This action cannot be undone.'
              }
            }
          }
        }
        this.$buefy.dialog.confirm({
          title: 'Delete playlist',
          message: message,
          confirmText: 'Delete',
          type: 'is-danger',
          onConfirm: () => {
            if (flag) {
              this.$buefy.dialog.confirm({
                message: 'Do you also want to delete the resources associated with this playlist?',
                cancelText: 'Archive resources',
                confirmText: 'Delete forever',
                type: 'is-danger',
                onConfirm: () => {
                  this.removePlaylist(id, true, true)
                },
                onCancel: () => {
                  this.globalLogger('onCancel')
                  this.loadingComponent = this.$buefy.loading.open()
                  var plRef = Object.assign({}, this.$store.getters.getPlaylist(id))
                  var plItems = [...plRef.items.filter(x => x)]

                  var count1 = 0
                  var archiveItemsCopy = []
                  for (let z = 0; z < this.archiveItems.length; z++) {
                    archiveItemsCopy[z] = this.archiveItems[z]
                  }

                  for (let i = 0; i < plItems.length; i++) {
                    if (plItems[i].resourceSize !== undefined && plItems[i].resourceSize !== null && plItems[i].resourceSize !== 0) { // samo 0 e dovolno
                      var zn = 1
                      for (let j = 0; j < archiveItemsCopy.length; j++) {
                        this.globalLogger(archiveItemsCopy[j].resName, plItems[i].resourceName)
                        this.globalLogger(archiveItemsCopy[j].resSize, plItems[i].resourceSize)
                        if (archiveItemsCopy[j].resName === plItems[i].resourceName && archiveItemsCopy[j].resSize === plItems[i].resourceSize) {
                          zn = 0
                        } else if (archiveItemsCopy[j].resName === plItems[i].resourceName) {
                          this.globalLogger('samo imeto')
                          archiveItemsCopy = archiveItemsCopy.filter(x => x.resName !== plItems[i].resourceName)
                        }
                      }
                      if (zn === 1) {
                        count1++
                        archiveItemsCopy.push({ 'resName': plItems[i].resourceName, 'resSize': plItems[i].resourceSize })
                      }
                    }
                  }
                  // this.globalLogger('archive items updated: ', this.archiveItems)
                  var dirRef = null
                  if (!this.getNotMigrated().includes(this.$store.state.uid)) {
                    dirRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/Playlists/' + id)
                  } else {
                    dirRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/Playlists/' + id)
                  }
                  var flag = 0
                  var count2 = 0
                  dirRef.listAll().then((dir) => {
                    dir.items.forEach(fileRef => {
                      fileRef.getDownloadURL().then((url) => {
                        const xhr = new XMLHttpRequest()
                        xhr.responseType = 'blob'
                        xhr.onload = (event) => {
                          const blob = xhr.response
                          var file = new File([blob], fileRef.name, {type: blob.type})
                          // this.archiveItems.push({ 'resName': fileRef.name, 'resSize': blob.size })
                          // this.globalLogger('archive items: ', this.archiveItems)
                          this.globalLogger('file', file)
                          let ref = null
                          if (!this.getNotMigrated().includes(this.$store.state.uid)) {
                            ref = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/PlaylistsArchive/' + fileRef.name)
                          } else {
                            ref = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/PlaylistsArchive/' + fileRef.name)
                          }
                          ref.put(file).then((snapshot) => {
                            ref.getDownloadURL().then((url) => {
                              var zn = 1
                              for (let j = 0; j < this.archiveItems.length; j++) {
                                if (this.archiveItems[j].resName === file.name && this.archiveItems[j].resSize === file.size) {
                                  this.globalLogger('zn e 0')
                                  zn = 0
                                } else if (this.archiveItems[j].resName === file.name) {
                                  this.globalLogger('samo imeto')
                                  this.archiveItems = this.archiveItems.filter(x => x.resName !== file.name)
                                }
                              }
                              if (zn === 1) {
                                count2++
                                this.globalLogger(count2, 'count2')
                                this.globalLogger('zn e 1')
                                this.archiveItems.push({ 'resName': file.name, 'resSize': file.size })
                              }
                              this.globalLogger('File ' + file.name + ' successfully uploaded at ' + url)
                            }).finally(() => {
                              this.globalLogger('finally new', this.archiveItems)
                              if (!this.getNotMigrated().includes(this.userId)) {
                                this.$store.state.database.ref('/neoslide/archive/' + this.workspaceId + '/playlists/').update({
                                  items: this.archiveItems
                                })
                              } else {
                                this.$store.state.database.ref('/archive/' + this.userId + '/playlists/').update({
                                  items: this.archiveItems
                                })
                              }
                              if (flag === 0) {
                                this.globalLogger('FLAG = 0')
                                this.removePlaylist(id, false, false)
                              }
                              flag = 1
                            }).finally(() => {
                              this.globalLogger('second finally')
                              this.globalLogger(count1, count2)
                              if (count1 === count2) {
                                this.globalLogger('uslov ispolnet')
                                this.loadingComponent.close()
                                this.$buefy.toast.open({
                                  duration: 3000,
                                  message: 'The resources are archived.'
                                })
                              }
                            })
                          }).catch(error => {
                            this.globalLogger('Submit files error: ', error)
                          })
                        }
                        xhr.open('GET', url)
                        this.globalLogger('url', url)
                        xhr.send()
                        // this.removePlaylist(id)
                      }).catch((error) => {
                        this.globalLogger('error', error)
                      })
                    })
                  })
                }
              })
            } else {
              this.globalLogger('else')
              this.removePlaylist(id, true, false)
            }
          }
        })
      }
    },
    removePlaylist (id, shouldLoad, isDelete) {
      var plToRemove = this.$store.getters.getPlaylist(id)

      var plToRemoveLog = Object.assign({}, plToRemove)
      plToRemoveLog.playlistId = id
      plToRemoveLog.ip_addr = this.jsonResp ? this.jsonResp.ip : ''
      plToRemoveLog.city = this.jsonResp ? this.jsonResp.city : ''
      var names = []
      for (let it in plToRemove.items) {
        names.push(plToRemove.items[it].name)
      }
      plToRemoveLog.playlistItems = names
      this.$analytics.logEvent('delete_playlist', plToRemoveLog)

      this.globalLogger('removePlaylist')
      if (shouldLoad) {
        this.loadingComponent = this.$buefy.loading.open()
      }
      let relatedClustersRef = this.$store.getters.getClustersForPlaylist(id)
      for (let cluster in relatedClustersRef) {
        this.$store.state.database.ref('/clusters/' + this.$store.state.uid + '/' + cluster).update({
          mainPlaylistId: ''
        })
      }
      let removePlaylistRef = null
      if (!this.getNotMigrated().includes(this.userId)) {
        removePlaylistRef = this.$store.state.database.ref('/neoslide/playlists/' + this.workspaceId + '/' + id)
      } else {
        removePlaylistRef = this.$store.state.database.ref('/playlists/' + this.userId + '/' + id)
      }
      removePlaylistRef.remove()
      if (this.campaignsAddOn) {
        if (this.campaignsToDelete.length > 0) {
          if (!this.getNotMigrated().includes(this.userId)) {
            for (let i = 0; i < this.campaignsToDelete.length; i++) {
              this.$store.state.database.ref('/neoslide/campaigns/' + this.workspaceId + '/' + this.clusterIds[i] + '/' + this.campaignsToDelete[i]).remove()
            }
          } else {
            for (let i = 0; i < this.campaignsToDelete.length; i++) {
              this.$store.state.database.ref('/campaigns/' + this.userId + '/' + this.clusterIds[i] + '/' + this.campaignsToDelete[i]).remove()
            }
          }
        }
      }
      var removePlaylistFilesRef = null
      if (!this.getNotMigrated().includes(this.$store.state.uid)) {
        removePlaylistFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/Playlists/' + id)
      } else {
        removePlaylistFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/Playlists/' + id)
      }
      removePlaylistFilesRef.listAll().then(dir => {
        dir.items.forEach(fileRef => {
          fileRef.delete().then(() => {
            this.globalLogger('deleted file' + fileRef.name)
          })
        })
        if (shouldLoad) {
          this.loadingComponent.close()
          if (isDelete) {
            this.$buefy.toast.open({
              duration: 3000,
              message: 'The resources are deleted.'
            })
          }
        }
      })
    },
    cancelAdd () {
      this.bPlaylistAdd = false
    },
    refreshData () {
      this.globalLogger('refreshData')
      if (this.$store.state.playlistsArchive !== null) {
        this.archiveItems = this.$store.state.playlistsArchive.items
        this.globalLogger('playlists archive: ', this.archiveItems)
      }
    },
    storageAlmostFull () {
      this.globalLogger('Storage almost full')
      this.totalStorageSize = 0
      for (let menu in this.menus) {
        var sum = 0
        var menuRef = Object.assign({}, this.$store.getters.getMenu(menu))
        if (menuRef.items !== undefined) {
          var menuItems = [...menuRef.items.filter(x => x.resourceName !== '')]
          menuItems = menuItems.filter((v, i, a) => a.findIndex(v2 => (v2.resourceName === v.resourceName)) === i)
          var noResources = menuItems.length
          if (noResources > 0) {
            for (let i = 0; i < menuItems.length; i++) {
              if (menuItems[i].resourceName !== '') {
                sum += menuItems[i].resourceSize
              }
            }
            this.totalStorageSize += sum
          }
        }
      }
      // archive begin
      if (this.menusArchive !== null) {
        for (let i = 0; i < this.menusArchive.items.length; i++) {
          this.totalStorageSize += this.menusArchive.items[i].resSize
        }
      }
      if (this.playlistsArchive !== null) {
        for (let x = 0; x < this.playlistsArchive.items.length; x++) {
          this.totalStorageSize += this.playlistsArchive.items[x].resSize
        }
      }
      if (this.specialOffersArchive !== null) {
        for (let y = 0; y < this.specialOffersArchive.items.length; y++) {
          this.totalStorageSize += this.specialOffersArchive.items[y].resSize
        }
      }
      // archive end
      for (let playlist in this.playlists) {
        var sum1 = 0
        var playlistRef = Object.assign({}, this.$store.getters.getPlaylist(playlist))
        if (playlistRef.items !== undefined) {
          var playlistItems = [...playlistRef.items.filter(x => x.resourceName !== '')]
          playlistItems = playlistItems.filter((v, i, a) => a.findIndex(v2 => (v2.resourceName === v.resourceName)) === i)
          var noResources1 = playlistItems.length
          if (noResources1 > 0) {
            for (let i = 0; i < playlistItems.length; i++) {
              if (playlistItems[i].resourceName !== '') {
                sum1 += playlistItems[i].resourceSize
              }
            }
            this.totalStorageSize += sum1
          }
        }
      }
      for (let offer in this.specialOffers) {
        var sum2 = 0
        var offerRef = Object.assign({}, this.$store.getters.getSpecialOffer(offer))
        if (offerRef.items !== undefined) {
          var offerItems = [...offerRef.items.filter(x => x.resourceName !== '')]
          offerItems = offerItems.filter((v, i, a) => a.findIndex(v2 => (v2.resourceName === v.resourceName)) === i)
          var noResources2 = offerItems.length
          if (noResources2 > 0) {
            for (let i = 0; i < offerItems.length; i++) {
              if (offerItems[i].resourceName !== '') {
                sum2 += offerItems[i].resourceSize
              }
            }
            this.totalStorageSize += sum2
          }
        }
      }
      this.globalLogger('storage size: ', this.totalStorageSize)
      return (this.totalStorageSize >= 1020054732) // >= 95%
    },
    showPlaylistName (name) {
      if (name.length > 21) {
        return name.substr(0, 21) + '...'
      }
      return name
    }
  }
}
</script>

<style scoped>
  .box {
    border: 0.5px solid rgb(212, 212, 212);
  }
</style>



// WEBPACK FOOTER //
// src/components/playlists/Playlists.vue